import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { first } from 'rxjs';
import { ApiServiceService } from 'src/app/_service/api-service.service';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { NgxSpinnerService } from 'ngx-spinner';
import { DatePipe } from '@angular/common';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-course-assigned',
  templateUrl: './course-assigned.component.html',
  styleUrls: ['./course-assigned.component.scss']
})
export class CourseAssignedComponent implements OnInit {

  MeetingOptions:any;
  participantsptions:any;
  // districts:any=['Salem','Karur','Namakkal','Trichy'];
  createmeetingform !:FormGroup;
  constituencies!:any;
  meeting_name: any;
  meeting_time: any;
  meeting_date: any;
  participants: any;
  meeting_type: any;
  meeting_location: any;
  spinner: boolean;
  hidden:boolean=true;
  dropdownList : string[]= [];
  dropdownSettings: IDropdownSettings = {};
   users: any = JSON.parse(localStorage.getItem('login_user_details'));
 
  selectedItems = [];
  
  dropDownForm: FormGroup;
  tableshow: boolean=false;
  isButtonDisabled :boolean=false;
  CM_id: any;
  editmeetingform !:FormGroup;
  da_district:string;
  district: any = this.ApiService.user_details.district;
  constituency: any = this.ApiService.constituency;
  courses: any;
  userDistrict: any = this.ApiService.user_details.district;
  userConstituency: any = this.ApiService.user_details.constituency;
  userId: any = this.ApiService.user_details.id;
  ob_data: any;
  mentor_data: any;
  CM_course_image: any;
  coursedatas: any=[];
  completed_course: any[];
  upcoming_course: any[];
  CM_type: any;
  CM_Description: any;
  Topic: any;



  onItemSelect(item: any) {
    console.log('onItemSelect', item);
  }
  onItemDeSelect(item: any) {
      console.log('onItemDeSelect', item);
  }
  onSelectAll(items: any) {
      console.log('onSelectAll', items);
  }
  onUnSelectAll() {
      console.log('onUnSelectAll fires');
  }


  constructor(private fb: FormBuilder,private ApiService: ApiServiceService,private router:Router,private spinnerService: NgxSpinnerService,
    public datepipe:DatePipe) {
    this.createmeetingform= this.fb.group({
      course_name: ['',[Validators.required, Validators.pattern('[A-Za-z ]{1,32}')]],
      district:[this.current_date,Validators.required ],
      constituency:[this.current_time,Validators.required],
      organizer:['',Validators.required],
      course_start_date:['',Validators.required],
      course_end_date: ['', Validators.required],
      course_start_time:['',Validators.required],
      course_end_time: ['', Validators.required],
      volunteer1:['',Validators.required],
      volunteer2: ['', Validators.required],
      user_id:[''],
      comments:[''],
      course_location:['',Validators.required],
      status:[''],
      image:['']
    });
    this.editformInitialize('false');
    this.district = JSON.parse(localStorage.getItem('user_district'));

  }


  dtOptions: DataTables.Settings = {};
  date:any;
  mentor_id: any = JSON.parse(localStorage.getItem('login_user_details'));

  ngOnInit():void{
   
    this.showSpinner();
    this.handleBackButtonForModal();

    // this.ApiService.get_courese_byuserId(this.mentor_id.id).subscribe((data: any) => {
    //   // this.coursedatas= data.course;
    //    const today = new Date();
    //    this.upcoming_course = [];
    //    this.completed_course = [];
    //    console.log("today" + today,data);
       
    //    data.course.forEach((course: any) => {
    //      const courseDate = new Date(course.course_date);
    //      if (courseDate >= today) {
    //        this.upcoming_course.push(course);
    //      } else {
    //        this.completed_course.push(course);
    //      }
    //    });
    //   console.log(this.upcoming_course,this.completed_course);
      
    //    this.coursedatas = data.course;
       
    //  });
    // console.log(this.mentor_id.id)

    this.ApiService.get_courese_byuserId(this.mentor_id.id).subscribe({
      next: (data: any) => {
        console.log(data)
          const today = new Date();
          today.setHours(0, 0, 0, 0); 
          const last7Days = new Date();
          last7Days.setHours(0, 0, 0, 0);
          last7Days.setDate(today.getDate() - 7); // Set date to 7 days ago

          this.upcoming_course = [];
          this.completed_course = [];
          console.log("Today: " + today);
          console.log("Last 7 Days: " + last7Days);
          
          // Separate upcoming and completed courses
          data.course.forEach((course: any) => {
            console.log(course)
              const courseDate = new Date(course.course_date);
              courseDate.setHours(0, 0, 0, 0); // Normalize to start of the day

              if (courseDate >= today) {
                  // Course is upcoming (today or later)
                  this.upcoming_course.push(course);
              } else if (courseDate >= last7Days && courseDate < today) {
                  // Course is within the last 7 days (excluding today)
                  this.completed_course.push(course);
              }
          });

          console.log("Upcoming Courses:", this.upcoming_course);
          console.log("Completed Courses (Last 7 Days):", this.completed_course);
      },
      error: (error) => {
          console.error("Error fetching courses:", error);
      }
  });





    // const userCategory = localStorage.getItem('category');
    // console.log(userCategory);
    // this.createmeetingform.get('district').value(this.userDistrict);
    // this.createmeetingform.get('constituency').value(this.userConstituency);
      // console.log(this.userDistrict,this.userConstituency,this.ApiService.user_details,"djnjdn");
    // Remove double quotation marks from userCategory
    // const cleanedUserCategory = userCategory.replace(/"/g, '');
    // console.log(cleanedUserCategory);
    // if (cleanedUserCategory === 'OB') {
    //   console.log('Inside if block');
    //   this.isButtonDisabled = true;
    // } else {
    //   console.log('Inside else block');
    //   this.isButtonDisabled = false;
    // }
    this.date = new Date();

      this.ApiService.courseAssignedToMentor(this.users.first_name).subscribe((data: any) => {
       console.log(data, "sknsdnjs");
       this.mentor_data = data;  
       console.log('this.mentor_data: ', this.mentor_data);
     })
    
    

    // this.ApiService.getOBDetailsForDistrictOccurance().subscribe((data) => {
    //   this.ob_data = data;
    // })
    
// document.write(today);
    this.customers=[];
    this.showSpinner();
    this.ApiService.getDistrictOccurance().subscribe((data:any) => {
      
      this.customers=data;
      this.tableshow=true;
      //console.log(this.customers.length);
      //console.log(obj.data.length);
      console.log(this.customers);
      
    })
    
     this.ApiService.getCourses().subscribe((data: any) => {
       console.log(data, "s,mfdnsd");
       this.courses = data;
     
      
      
      //console.log(this.customers.length);
      //console.log(obj.data.length);
      console.log(this.customers,"dsdksbk");
      })

    // this.getdata();
    // this.ApiService.viewtableOB();
    // this.ApiService.viewtableDA();
    // this.ApiService.viewtableSA();
    // this.ApiService.viewtableOBapprove();
    // this.ApiService.viewtablemeeting();
    this.dtOptions = {
      pagingType: 'full_numbers',
      order: [2,'asc']
    };

    const all_districts = this.ApiService.meeting_districts;
    this.dropdownList = all_districts;
  
   
    this.selectedItems = [
      { }
    ];
    this.dropDownForm = this.fb.group({
      meeting_district: [this.selectedItems]
  });
  this.da_district=localStorage.getItem('user_district');
 

  }
  //Default date time in form
  current_date:any;
  current_time;any;
  setCurrentdate(){
    this.current_date=this.datepipe.transform(new Date(), 'yyyy-MM-dd');
    this.current_time=this.datepipe.transform(new Date(), 'HH:mm');
    this.createmeetingform.get('district').setValue(this.userDistrict);
    this.createmeetingform.get('constituency').setValue(this.userConstituency);
    this.createmeetingform.get('user_id').setValue(this.userId);
  }
  public showSpinner(): void {
    this.spinnerService.show();
    }

  customers:any=[];
  

  postdata(angForm1 : any) //angForm1
    {
    console.log(angForm1.value);

          this.ApiService.createDistrictOccurance(angForm1.value).pipe().subscribe(
            data => {
              console.log(data);
              this.spinnerService.hide();
            
              setTimeout(function () {
                Swal.fire({
                  title: "Course District Occurrence has been created!",
                  icon: "success",
                  confirmButtonText: "Okay",
                  confirmButtonColor:'#015792',
                  iconColor: "#015792" // Set the icon color here
                }).then(() => {
                  window.location.reload();
                });
              }, 100);
            },
            
              
              error => {
                console.log(error);
              });
          }
    
 
    delete_CM(id : any){
      console.log(id)
      if(confirm("Are you sure want to cancel this District Occurance ?")) {
        console.log("Implement delete functionality here");
          this.ApiService.deleteDistrictOccurance(id)
          .pipe()
          .subscribe(
            data => {
              Swal.fire({
                title: "Course District Occurrence has been deleted Successfully!",
                icon: "success",
                confirmButtonText: "Okay",
                confirmButtonColor:'#015792',
                iconColor: "#015792" // Set the icon color here
              }).then(() => {
                window.location.reload();
              });
            },
            

          error => {
              console.log(error);
          });

  }
}

    

  radiobutton(option:any){
    this.MeetingOptions=option;
    // console.log(this.MeetingOptions);
  }
  Participants(a:any){
    this.participantsptions=a;
  }
  CM_course_name: any;
  CM_district: any;
  CM_constituency: any;
  CM_organizer: any;
  CM_startDate: any;
  CM_endDate: any;
  CM_startTime: any;
  CM_endTime: any;
  CM_volunteer1: any;
  CM_volunteer2: any;
  CM_location: any;
  CM_status: any;
  CM_comments: any;
  CM_session_link: any;


  editfield:boolean=false;
  editTopic:boolean=false;

  buttonviewmeeting(a:any,editbutton:any ){
    console.log(a,editbutton);
    //console.log(a.date)
    if (editbutton == 'edit') {
      this.editfield = true;
    } else {
      this.editfield = false;
    }
      this.CM_course_name=a.course_name;
      this.Topic =a.course_topic;
      if(this.Topic==="Technical"){
        this.editTopic=true;
      }
      else{
        this.editTopic=false;

      }
      this.CM_Description=a.course_des;
      this.CM_startDate = this.datepipe.transform(a.course_date, 'dd-MM-yyyy');
      // this.CM_organizer = a.organizer;
      // this.CM_endDate=this.datepipe.transform(a.end_date, 'dd-MM-yyyy');
      this.CM_startTime=a.course_time;
      // this.CM_endTime=a.end_time;
      // this.CM_volunteer1=a.volunteer1;
      // this.CM_volunteer2 = a.volunteer2;
      // this.CM_location = a.location;
      this.CM_type = a.typeofcourse;
      if(this.CM_type !="Technical"){
        this.editTopic=false;
      }
      else{
        this.editTopic=true;

      }
      this.CM_comments = a.comment;
      // this.CM_id = a.id;
      this.CM_session_link = a.online_meet_link;
      // this.CM_course_image=a.image;
      // this.editmeetingform.get('comments').setValue(a.comments);
      // this.editmeetingform.get('course_name').setValue(a.course_name);
      // this.editmeetingform.get('organizer').setValue(a.organizer);
      
          //this.editformInitialize(false);
      
   
    // this.editmeetingform.get('meeting_date').setValue(a.date);
    // this.editmeetingform.get('meeting_time').setValue(a.time);
          //this.editmeetingform.controls['meeting_date'].disable();
        //  this.editmeetingform.controls['meeting_date'].setValue(this.CM_date);
        //  this.editmeetingform.controls['meeting_date'].setValue(this.CM_time);

    }


          editformInitialize(a){
            this.editmeetingform= this.fb.group({
           course_name: ['',[Validators.required, Validators.pattern('[A-Za-z ]{1,32}')]],
      district:[this.current_date,Validators.required ],
      constituency:[this.current_time,Validators.required],
      organizer:['',Validators.required],
      course_start_date:['',Validators.required],
      course_end_date: ['', Validators.required],
      course_start_time:['',Validators.required],
      course_end_time: ['', Validators.required],
      volunteer1:['',Validators.required],
      volunteer2: ['', Validators.required],
      user_id:[''],
      comments:[''],
      course_location:['',Validators.required],
              status: [''],
      session_link:[''],
      image:['']
          });
          }
        
          updatedata(updateform,id){
            console.log(updateform,id);  
            this.spinner = true;
            this.ApiService.updateDistrictOccurance(this.CM_id,updateform.value).pipe().subscribe(
              data => {
                console.log(data);
                this.spinnerService.hide();
              
                setTimeout(function () {
                  Swal.fire({
                    title: "Course District Occurrence detail has been updated!",
                    icon: "success",
                    confirmButtonText: "Okay",
                    confirmButtonColor:'#015792',
                    iconColor: "#015792" // Set the icon color here
                  }).then(() => {
                    window.location.reload();
                  });
                }, 100);
              },
              
              error => {
                console.log(error);
              });
          }

//reset form values in createform
  Formreset(){
    this.createmeetingform.reset();
    this.hidden=true;
    this.MeetingOptions='';
    //this.participantsptions='';
}
handleBackButtonForModal() {
  // Push initial state to history
  history.pushState(null, '', window.location.href);

  window.onpopstate = () => {
    const modal = document.querySelector('.modal.show') as HTMLElement;
    if (modal) {
      // Find the close button inside the modal and trigger a click event on it
      const closeButton = modal.querySelector('.close') as HTMLElement;
      if (closeButton) {
        closeButton.click();
      }

      // Prevent default back navigation
      history.pushState(null, '', window.location.href);
    } else {
      // Allow back navigation as usual if modal is not open
      this.router.navigate(['previous-page']); // Replace 'previous-page' with the actual route you want to navigate to
    }
  };
}
ngOnDestroy(): void {
  // Cleanup event listener to avoid memory leaks
  window.onpopstate = null;
}

}
